import React, { ChangeEvent, KeyboardEvent, MouseEvent, useCallback } from 'react';
import cn from 'classnames';
import { TreeItem } from './TreeItem';
import useTree from './useTree';
require("./Tree.css");
var styles = {
  "Root": "Tree-module-Root_3VG"
};
import { TreeNode } from './Tree.heplers';
import { CheckInfo, ExpandedInfo, ITreeProps } from './Tree.interfaces';
export const Tree = ({
  treeData,
  defaultExpandedKeys,
  defaultCheckedKeys,
  checkable,
  itemClassName,
  itemStyle,
  rootClassName,
  rootStyle,
  innerRef,
  controlRef,
  onExpand,
  onCheck,
  ariaLabelledby = 'tree',
  roleTreeItem
}) => {
  const {
    list,
    checkedKeys,
    expandedKeys,
    postOrderTraversal,
    setCheckedKeys,
    setExpandedKeys,
    setFocusToItem
  } = useTree({
    treeData,
    defaultExpandedKeys,
    defaultCheckedKeys,
    checkable
  });
  const onNodeExpand = useCallback((event, node) => {
    const {
      key
    } = node;
    const expandedKeysSet = new Set(expandedKeys);
    if (expandedKeysSet.has(key)) {
      for (let el of postOrderTraversal(node)) {
        expandedKeysSet.delete(el.key);
      }
    } else {
      expandedKeysSet.add(key);
    }
    if (onExpand) {
      const eventObj = {
        node,
        expanded: expandedKeysSet.has(key),
        nativeEvent: event.nativeEvent
      };
      onExpand([...expandedKeysSet.values()], eventObj);
    }
    setExpandedKeys([...expandedKeysSet.values()]);
  }, [expandedKeys, onExpand, postOrderTraversal, setExpandedKeys]);
  const onChecked = useCallback((event, node) => {
    const {
      key,
      parent
    } = node;
    const checkedKeysSet = new Set(checkedKeys);
    if (checkedKeysSet.has(key)) {
      for (let el of postOrderTraversal(node)) {
        checkedKeysSet.delete(el.key);
      }
    } else {
      for (let el of postOrderTraversal(node)) {
        checkedKeysSet.add(el.key);
      }
    }
    if (parent && parent.children) {
      const isAllChildrenChecked = parent.children.every(child => checkedKeysSet.has(child.key));
      if (isAllChildrenChecked) {
        checkedKeysSet.add(parent.key);
      }
      if (!isAllChildrenChecked && checkedKeysSet.has(parent.key)) {
        checkedKeysSet.delete(parent.key);
      }
    }
    if (onCheck) {
      const eventObj = {
        event: 'check',
        node,
        checked: checkedKeysSet.has(key),
        nativeEvent: event.nativeEvent
      };
      onCheck([...checkedKeysSet.values()], eventObj);
    }
    setCheckedKeys([...checkedKeysSet.values()]);
  }, [checkedKeys, onCheck, postOrderTraversal, setCheckedKeys]);
  return /*#__PURE__*/React.createElement("div", {
    className: cn(styles.Root, rootClassName),
    ref: innerRef || controlRef,
    style: rootStyle,
    "aria-labelledby": ariaLabelledby,
    role: ariaLabelledby
  }, list?.map(node => /*#__PURE__*/React.createElement(TreeItem, {
    key: node.key,
    node: node,
    onNodeExpand: onNodeExpand,
    onChecked: onChecked,
    isChecked: checkedKeys.includes(node.key),
    checkable: checkable,
    itemClassName: itemClassName,
    itemStyle: itemStyle,
    setFocusToItem: setFocusToItem,
    roleTreeItem: roleTreeItem
  })));
};
if (process.env.NODE_ENV !== 'production') {
  Tree.displayName = 'Tree';
}